import React from 'react';
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {DenmarkResponsibleGamingButtonsBox} from "./boxes/denmark.responsible-gaming-buttons.box";
import {
    BlankHorizontalSeparatorBox
} from "../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {DenmarkSafeToPlayButtonComponent} from "./safe-to-play-button/denmark.safe-to-play-button.component";
import {DenmarkSelfExclusionButtonComponent} from "./self-exclusion/denmark.self-exclusion-button.component";
import {DenmarkSelfTestButtonComponent} from "./self-test-button/denmark.self-test-button.component";

export const DenmarkResponsibleGamingButtonsComponent = observer(class DenmarkResponsibleGamingButtonsComponent extends OrbitComponent {
    render() {
        const multiplier = this.services.mediaQuery.sAndBelow ? 1 : 1;
        return (
            <DenmarkResponsibleGamingButtonsBox>
                <DenmarkSafeToPlayButtonComponent/>
                <BlankHorizontalSeparatorBox multiplier={multiplier}/>
                <DenmarkSelfExclusionButtonComponent/>
                <BlankHorizontalSeparatorBox multiplier={multiplier}/>
                <DenmarkSelfTestButtonComponent/>
            </DenmarkResponsibleGamingButtonsBox>
        );
    }
});